module.exports = __webpack_public_path__ + "media/images/icon_message-383a6b00930cbd0fb374993efafdeb96.png";